import { render, staticRenderFns } from "./ModalInsurance.vue?vue&type=template&id=0d3336e1"
import script from "./ModalInsurance.vue?vue&type=script&lang=js"
export * from "./ModalInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports